import {
  KEY_USER_LOCAL_STORAGE,
  KEY_ACCESS_LOCAL_STORAGE,
  KEY_TOKEN_LOCAL_STORAGE
} from '@/config/constants'

import Cookies from 'js-cookie'

const COOKIE_PATH = '/'
const COOKIE_DOMAIN = process.env.VUE_APP_URI_DOMAIN
const cookieAttributes = (expires) => ({
  path: COOKIE_PATH,
  secure: true,
  sameSite: 'None',
  expires,
  domain: COOKIE_DOMAIN
})
const cookieRemovalAttributes = [
  { path: COOKIE_PATH, domain: COOKIE_DOMAIN, secure: true, sameSite: 'None' },
  { path: COOKIE_PATH, secure: true, sameSite: 'None' }
]

function persistCookie(name, value, expires = 6000) {
  if (typeof value !== 'string' || !value) {
    return false
  }

  try {
    if (!removeCookie(name)) {
      return false
    }
    Cookies.set(name, value, cookieAttributes(expires))
    return Cookies.get(name) === value
  } catch (error) {
    return false
  }
}

function removeCookie(name) {
  try {
    cookieRemovalAttributes.forEach(attributes => Cookies.remove(name, attributes))
    return Cookies.get(name) === undefined
  } catch (error) {
    return false
  }
}

export async function setToken(data, exp = 6000) {
  return persistCookie(KEY_TOKEN_LOCAL_STORAGE, data, exp)
}

export async function setDataUser(data, exp = 6000) {
  return persistCookie(KEY_USER_LOCAL_STORAGE, data, exp)
}

export async function setDataAccess(data, exp = 6000) {
  return persistCookie(KEY_ACCESS_LOCAL_STORAGE, data, exp)
}

export async function getToken() {
  return Cookies.get(KEY_TOKEN_LOCAL_STORAGE)
}

export async function getUserData() {
  return Cookies.get(KEY_USER_LOCAL_STORAGE)
}

export async function getAccessData() {
  return Cookies.get(KEY_ACCESS_LOCAL_STORAGE)
}

export function clearToken() {
  return [
    KEY_USER_LOCAL_STORAGE,
    KEY_TOKEN_LOCAL_STORAGE,
    KEY_ACCESS_LOCAL_STORAGE
  ].map(removeCookie).every(Boolean)
}
